<template>

  <v-layout row wrap>
    <v-flex xs12 sm4 md4 lg4 xl4 style="overflow-y: scroll;max-height: 75vh; scrollbar-color: #001744 #dadada;scrollbar-width: thin">
      <div>
        <NewInbox :chatMenager="chatMenager" @created="inboxWithMessageCreated"></NewInbox>
      </div>
      <v-list two-line style="margin-right: 10px">
        <template v-for="(item, index) in inboxes">
          <v-list-tile :key="index" avatar ripple @click="activeInbox=item" :style="item.id==activeInbox.id ? 'background-color: #eaeaea' : ''">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.name }}
                <span style="color:#545353;font-size:0.9rem">
                ({{getUsersFullname(item.users)}})
                </span>
              </v-list-tile-title>
              <v-list-tile-sub-title>{{ item.last_message }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-badge v-if="item.new_message > 0"  color="orange"  left>
                <template v-slot:badge>
                  <span>{{ item.new_message }}</span>
                </template>
                <v-icon large color="green lighten-1">mail</v-icon>
              </v-badge>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-flex>
    <v-flex id="message-container" lg8 md8 sm8 style="overflow-y: scroll;max-height: 70vh; scrollbar-color: #6a6969 #d0cdcd;scrollbar-width: thin; scroll-margin-left: 150px;" xl8
            xs12>
      <div style="margin-left: 1rem"  id="container" :style="getStyle">
        <div style="margin-right: 1px" >
          <div v-for="(message,index) in this.messages" :key="'message-' + index"
               style="display: flex;flex-flow: column wrap;">
            <div v-if="message.author_id == user.id">
              <div  style="color:white;border-radius: 10px 0px 0px 10px; margin-left:60%;max-width: 40%;align-content: flex-start;width: 40%;padding: 1rem 1rem; margin-right: 20px; background-color: rgb(0,110,98);margin-top: 1rem">
                {{message.message}}
              </div>
              <div style="color:grey;font-size:.8rem;text-align: right" v-if="lastReaded[message.id]"> Przeczytane przez {{lastReaded[message.id].map(getUserName).join(', ')}}</div>

            </div>
            <div v-else >
              <span v-if=" index > 0 ? messages[index].author_id != messages[index-1].author_id : true" style="color: gray;font-size:.8rem">
                {{getUserName(message.author_id)}}
              </span>
              <div style="border-radius: 0px 10px 10px 0px; text-shadow: 1px 1px white; max-width: 40%;padding: 1rem 1rem; background-color: #f1f1f1;margin-top:1rem">
                {{message.message}}
              </div>
              <div style="color:grey;font-size:.8rem" v-if="lastReaded[message.id]"> Przeczytane przez {{lastReaded[message.id].map(getUserName).join(', ')}}</div>
            </div>
          </div>
        </div>

        <div class="message-input_box">
          <v-layout>
            <v-flex x11>
              <div>
                <input class="input-message" v-model="messageModel" @keydown.enter="sendMessage" type="text" placeholder="Napisz wiadomość" >
              </div>
            </v-flex>
            <v-flex xs1>
              <v-icon @click="sendMessage" style="margin-top: 1.2rem;margin-left: -1rem;color:#00c0a6">fas send</v-icon>
            </v-flex>
          </v-layout>

        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import './NewInbox.vue'
import Acl from '@/plugins/Acl'
import ChatFactory from "@/plugins/ChatFactory"
import NewInbox from "./NewInbox.vue"

export default {
  components: {NewInbox},
  data() {
    return {
      user: (new Acl()).user,
      inboxes: [],
      loading: true,
      activeInbox: null,
      messageModel: '',
      interval: null,
      pending: false,
      messages: [],
      chatMenager: ChatFactory.getChat()
    }
  },
  computed:{
    lastReaded(){
      let ack = {}
      this.activeInbox.ack.forEach(el =>
        ack[el.last_message_id] ? ack[el.last_message_id].push(el.user_id) : ack[el.last_message_id] = [el.user_id])
      return ack
    },
    getStyle(){
      return 'min-height:90vh'
    },
    users(){
      return this.$store.state.users
    }
  },
  watch: {
    activeInbox: function (newVal) {
      this.messages = []
      this.$http.get(`messenger/inbox/${newVal.id}/messages`).then(data => {
        this.messages = data.data.reverse()
        let lastMessageId = this.messages.length > 0 ? this.messages[this.messages.length - 1].id : 0
        this.chatMenager.waitForNewMessages(this.addNewMessages, newVal, lastMessageId)
        setTimeout(this.scroll, 200)
        if (newVal.new_message > 0) {
          this.chatMenager.ack(lastMessageId, newVal.id)
          newVal.new_message = 0
        }
      })
    }
  },
  created() {
    this.$http.get('messenger/inbox').then(data => {
      this.inboxes = data.data
      if (this.inboxes.length > 0) {
        this.activeInbox = this.inboxes[0]
      }
      this.chatMenager.waitForNewInbox((resp) => this.inboxes.splice(0, 0, resp.data))
      this.chatMenager.waitForAck((resp) => {
        let inbox = this.inboxes.find(i => i.id == resp.data.inbox_id)
        let ack = inbox ? inbox.ack.find(el => (el.user_id == resp.data.user_id)) : false
        ack ? ack.last_message_id = resp.data.last_message_id : null
      })
    })
  },
  destroyed() {
    this.chatMenager.stop()
  },
  methods:{
    inboxWithMessageCreated(inbox){
      this.inboxes = [inbox].concat(this.inboxes)
      this.activeInbox = inbox
    },
    scroll(){
      let element = document.querySelector('#message-container')
      if(element == undefined) {
        return
      }

      if(this.messages.length > 5){
        element.scrollTop = element.scrollHeight
      }else{
        element.scrollTop = 0
      }
    },
    getUsersFullname(users){
      if(!users || users.length < 1){
        return '?'
      }
      return users.map(user => user.name + " " + user.surname).join(", ")
    },
    getUserName(id){
      let user = this.users.find( el=> el.id == id)
      return user ? user.name + " " + user.surname : 'Nieznany nadawca'
    },
    getStyleHeight(){
      return `height: ${window.screen.height-64}px`
    },
    sendMessage(){
      if(this.messageModel == "" || this.activeInbox == null || this.inboxes.length == 0 ){
        return
      }
      this.chatMenager.sendMessage(this.messageModel, this.activeInbox.id)
      this.messageModel = ""

      if(this.activeInbox != this.inboxes[0]){
        this.inboxes = this.inboxes.filter(el => el.id != this.activeInbox.id)
        this.inboxes = [this.activeInbox].concat(this.inboxes)
      }

    },
    addToInbox(newMessages){
      if(newMessages.length < 1 || this.inboxes.length == 0) {
        return
      }

      let inbox = this.inboxes.find(inbox => inbox.id == newMessages[0].inbox.id)
      if(!inbox) {
        return
      }

      if(newMessages[0].id > inbox.last_message_id) {
        inbox.last_message = newMessages[0].message
        inbox.new_message = newMessages.length == 1 ? inbox.new_message + 1 :
          newMessages.reduce((currentVal, msg) => msg.id > inbox.last_message_id ? currentVal + 1 : currentVal, 0)
        inbox.last_message_id = newMessages[0].id
        let ack = inbox.ack.find(el => el.user_id == newMessages[0].author_id)

        if(ack && ack.last_message_id < newMessages[0].id){
          ack.last_message_id = newMessages[0].id
        }

        this.inboxes = this.inboxes.sort((i1,i2) => i1.last_message_id < i2.last_message_id  ? 1 : -1)
      }
    },
    addNewMessages(newMessages){
      this.addToInbox(newMessages) //sync other inbox state when new message, work only when websocket is enabled
      if(this.messages.length > 0 && newMessages.length > 0){
        let lastId = this.messages[this.messages.length-1].id

        if(lastId >= newMessages[0].id){
          return
        }

        let msgToPush = []
        for(let i = 0;i<= newMessages.length-1;i++){

          if(newMessages[i].id <= lastId){
            break
          }

          if(newMessages[i].inbox_id != this.activeInbox.id){
            continue
          }

          msgToPush.push(newMessages[i])
        }
        if(msgToPush.length == 0){
          return
        }

        this.messages.push(...msgToPush.reverse())
        this.scroll()

        if (msgToPush[0].author_id != this.user.id) {
          this.chatMenager.ack(msgToPush[0].id, this.activeInbox.id)
        }

        this.activeInbox.new_message = 0
      }
    }
  },
}
</script>
<style>
#container {
  position: relative;
  margin-bottom: 60px;
}
.message-input_box{
  position:fixed;
  right: 0;
  bottom: 0px;
  width:66.6%;
  height:60px;
  border-radius: 15px 50px 50px 0;
  background-color: white;
}
.input-message{
  text-decoration: none;
  background: #f1f1f1;
  box-shadow: red;
  width: 35rem;
  max-height: 1.5rem ;
  margin-left: .5rem;
  margin-top: 1rem;
  width:100%;
  outline:none;
  padding: 1.2rem .5rem;
  border: 2px solid #262E38;
  border-radius: 50px 50px 50px 50px;
  color: black;
}
body{
  overflow: hidden;
}

</style>

